import { useCallback, useEffect, useState } from "react";

export function useSessionParam(name: string) {
  const urlValue = new URLSearchParams(window.location.search).get(name) ?? null;

  const [value, setValue] = useState(() => {
    if (urlValue !== null) return urlValue;
    try {
      const value = localStorage.getItem(name);
      return value ?? "";
    } catch {
      return "";
    }
  });

  useEffect(() => {
    if (urlValue === null) return;
    const url = new URL(window.location.href);
    url.searchParams.delete(name);
    window.history.replaceState(undefined, "", url);
  }, [name, urlValue]);

  return [
    value,
    useCallback(
      (value: string) => {
        setValue(value ?? "");
        try {
          if (value === "") localStorage.removeItem(name);
          else localStorage.setItem(name, value);
        } catch {
          // No-op
        }
      },
      [name]
    ),
  ] as const;
}
